import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@mui/material';
import { TextField, Button, Alert, Snackbar  } from '@mui/material'
import axios from 'axios'
import { useLocation } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { TbLoader } from 'react-icons/tb';

const useStyles = makeStyles((theme)=>({

  box:{
    maxWidth:'1800px',
    margin:'0 auto',
    padding:'0 20px',
  },
  itemAdviceEditBlockH1:{
    padding:'40px 0 20px 0px',
    fontWeight:'700',
    fontSize:'22px',
  },
  load:{
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
  },
  loadingIcon:{
    color:'#007235',
    fontSize:'50px',
    animation:'$loadSpin 5s infinite'
  },
  "@keyframes loadSpin":{
    from: { transform:'rotate(0deg)' },
    to: { transform:'rotate(1turn)' }
  },
  listDiv:{
    display:'flex',    
    padding:'20px 10px',
    borderBottom:'1px solid #e2e2e2',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      alignItems:'stretch',
    },
  },
  spanSpan:{
    width:'250px',
    fontWeight:'600',
    textAlign:'left',

    [theme.breakpoints.down(1025)]: {
      paddingBottom:'10px'
    },
  },
  ItemAdviceDivTextarea:{
    width:'800px',
    height:'100px',
    background:'#DEDEDE',

    [theme.breakpoints.down(1025)]: {
      width:'100%'
    },
  },
  ItemAdviceDivReactQuill:{
    display:'flex',    
    padding:'0px 0 40px 10px',
    borderBottom:'1px solid #ddd',
    height:'400px',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      
    },
  },
  ItemAdviceSpanReactQuill:{
    width:'250px',
    fontWeight:'600',
    textAlign:'left',

    [theme.breakpoints.down(1025)]: {
      textAlign:'center',
      padding:'10px 0'
      
    },
  },
  reactQuill:{
    width:'800px',
    height:'300px',

    [theme.breakpoints.down(1025)]: {
      width:'100%',
      height:'270px'
      
    },
  },
  bottmBtn:{
    display:'flex',
    justifyContent:'center'
  },
  
  }));

const ItemAdviceEdit = () => {
    const theme = useTheme();
    const classes = useStyles(theme);
    const location = useLocation();

    const [errSnack, setErrSnack] = useState(false);
    const [succSnack, setSuccSnack] = useState(false);

    const [iqId, setIqId] = useState(0);
    const [itId, setItId] = useState('');
    const [iqName, setIqName] = useState('');
    const [mbId, setMbId] = useState('');
    const [iqHp, setIqHp] = useState('');
    const [iqEmail, setIqEmail] = useState('');
    const [iqSubj, setIqSubj] = useState('');
    const [iqQuest, setIqQuest] = useState('');
    const [iqAnswer, setIqAnswer] = useState('');
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        window.scrollTo(0, 0);

        return () => {
          setIqId(0)
          setItId('')
          setIqName('')
          setMbId('')
          setIqHp('')
          setIqEmail('')
          setIqSubj('')
          setIqQuest('')
          setIqAnswer('')
        }
    }, [])

    const getItem = async() => {
        try {
          setLoading(true)
          const res = await axios.post('/api/adm/itemQaEditPageView/', {iq_id: location.state.iq_id})
    
          if(res.data.success === false) {
            setErrSnack(true)
            setLoading(false)
            return ;
          }
    
          const result = res.data.result

          setIqId(result['iq_id'])
          setItId(result['it_id'])
          setIqName(result['iq_name'])
          setMbId(result['mb_id'])
          setIqHp(result['iq_hp'])
          setIqEmail(result['iq_email'])
          setIqSubj(result['iq_subject'])
          setIqQuest(result['iq_question'])
          setIqAnswer(result['iq_answer'])
          setLoading(false)
      
        } catch (e) {
          setErrSnack(true)
          setLoading(false)
          console.log(e)
        }
      } 
    
      useEffect(() => {
        if(location.state.iq_id){
          getItem()
        }
      } , [location.state.iq_id])


      const editData = async() => {
        try {
            const res = await axios.post('/api/adm/itemQaEditView/', 
            {
                iq_id: iqId,
                iq_subject: iqSubj,
                iq_question: iqQuest,
                iq_answer: iqAnswer,
            } 
            )
      
            if(res.data.success === false){
              setErrSnack(true)
              console.log('실패')
              return ;
            }
      
            setSuccSnack(true)
            getItem()
            
          } catch (e) {
            setErrSnack(true)
            console.log(e)
          }
      }
    

    const snackClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        setErrSnack(false);
        setSuccSnack(false)
      };

  return (
    <div className={classes.itemAdviceEditBlock}>
      <div className={classes.box}>
        {loading ? (
          <div className={classes.load}>
            <TbLoader className={classes.loadingIcon}/>
          </div>
        ) : (
          <>
          <h1 className={classes.itemAdviceEditBlockH1}>상품문의 수정</h1>
  
          <div className={classes.listDiv}>
            <span className={classes.spanSpan}>번호</span>
            {iqId}
          </div>
          <div className={classes.listDiv}>
            <span className={classes.spanSpan}>상품 번호</span>
            {itId}
          </div>
          <div className={classes.listDiv}>
            <span className={classes.spanSpan}>이름</span>
            {iqName}
          </div>
          <div className={classes.listDiv}>
            <span className={classes.spanSpan}>회원아이디</span>
            {mbId}
          </div>
          <div className={classes.listDiv}>
            <span className={classes.spanSpan}>이메일</span>
            {iqEmail}
          </div>
          <div className={classes.listDiv}>
            <span className={classes.spanSpan}>휴대폰 번호</span>
            {iqHp}
          </div>
          <div className={classes.listDiv}>
            <span className={classes.spanSpan}>제목</span>
            <TextField 
                sx={{ width: '250px' }}
                hiddenlabel="true" 
                variant="outlined" 
                value={iqSubj}
                onChange={(e) => {setIqSubj(e.target.value)}}
            />
          </div>
          <div className={classes.listDiv}>
            <span className={classes.spanSpan}>질문</span>
            <textarea 
                value={iqQuest}
                onChange={(e) => setIqQuest(e.target.value)}
                className={classes.ItemAdviceDivTextarea}
            />
          </div>
          <div className={classes.ItemAdviceDivReactQuill}>
            <span className={classes.ItemAdviceSpanReactQuill}>답변</span>
            <ReactQuill 
                theme="snow" 
                value={iqAnswer} 
                onChange={(content, delta, source, editor) => {setIqAnswer(editor.getHTML())}}
                className={classes.reactQuill}
            />
          </div>
  
          <div className={classes.bottmBtn}>
            <Button 
              variant="contained"
              onClick={() => {editData()}} 
              style={{margin:'20px 0'}}
            >
              확인
            </Button>
          </div>
  
  
  
          <Snackbar 
            open={errSnack} 
            autoHideDuration={6000} 
            onClose={snackClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
          >
            <Alert severity="error">수행을 실패 하였습니다!</Alert>
          </Snackbar>
          <Snackbar 
            open={succSnack} 
            autoHideDuration={6000} 
            onClose={snackClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
          >
            <Alert severity="success">수행을 성공 하였습니다!</Alert>
          </Snackbar> 
          </>
        )}
      </div>
      
    </div>
  )
}

export default ItemAdviceEdit
